import { render, staticRenderFns } from "./SocialsModule.vue?vue&type=template&id=30b09b36&scoped=true&"
import script from "./SocialsModule.vue?vue&type=script&lang=js&"
export * from "./SocialsModule.vue?vue&type=script&lang=js&"
import style0 from "./SocialsModule.vue?vue&type=style&index=0&id=30b09b36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b09b36",
  null
  
)

export default component.exports